/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Welcome_ContinueInputs */



/**
* | output |
* | --- |
* | "Continue" |
*
* @param {Onboarding_Welcome_ContinueInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_welcome_continue = /** @type {((inputs?: Onboarding_Welcome_ContinueInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Welcome_ContinueInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ga verder")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer")
	return /** @type {LocalizedString} */ ("Continue")
});